<script>
import NtvText from '../Text';
import NtvIcon from '../Icon';

export default {
  name: 'NtvErrorMessage',

  components: {
    NtvText,
    NtvIcon
  },

  props: {
    /**
     * The error message provided can be one messages or a list of messages.
     */
    message: {
      type: [String, Array],
      default: ''
    },
    /**
     * Prevent the error message from wrapping within the width of the input
     */
    preventWrap: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <div
    :class="preventWrap ? 'whitespace-no-wrap' : ''"
    class="ntv-error-message flex items-center"
    v-if="message"
  >
    <ntv-icon
      color="danger"
      name="timesCircle"
      size="default"
      use-fa
    />
    <ntv-text
      class="pl-md"
      color="danger"
      :text="message"
    />
  </div>
</template>
